import React from 'react'

const HorizontalRule = () => <hr />

export default HorizontalRule



// WEBPACK FOOTER //
// ./src/components/sitewide/HorizontalRule/index.js